import React, { Component } from "react";
//import TableComp from '../../../../components/_utils/table'
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import {
    Button,
    Card,
    Col,
    Form,
    notification,
    Popconfirm,
    Row,
    Tooltip,
    Drawer
} from "antd";
import Request, { API_URL } from "../../../request";
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import styles from "../country/all/styles.less";
import rightAuth from "../../../components/_utils/userRights";
import { RightsWrapper } from "../../../components/_utils/utils";


@Form.create()
class AddQualificationScore extends Component {
    state = {
        visible: true
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    componentDidMount() {
        let {record, form:{setFieldsValue}} = this.props
        if(record && record._id) {
            setTimeout(()=>{
                setFieldsValue(record)
            },50)
        }
    }

    handleSubmit = (e) => {
        let { form, record } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            let x = null
            if(record && record._id) {
                values._id = record._id;
                x = await Request.updateQualificationScore(values)
            }else {
                x = await Request.addQualificationScore(values)
            }
            
            if (x.success) {
                notification.success({
                    message: x.message
                })
            } else {
                notification.error({
                    message: x.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator } } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Percentage',
                    key: 'percentage',
                    type: 'number',
                    required: true,
                    style: { width: 320 },
                },
                {
                    label: 'CGPA 10.0',
                    key: 'cgpa10',
                    type: 'number',
                    required: true,
                    style: { width: 320 },
                },
                {
                    label: 'Letter Grade',
                    key: 'letterGrade',
                    required: true
                },
                {
                    label: 'GPA 4',
                    key: 'gpa4',
                    type: 'number',
                    required: true,
                    style: { width: 380 },
                },
                {
                    label: 'GPA 5',
                    key: 'gpa5',
                    type: 'number',
                    required: true,
                    style: { width: 380 },
                }
            ]
        }
        return (
            <Drawer
                title={`${this.props.record && this.props.record._id ? "Update" : "Add"} Qualification Score`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}


class AllQualificationScores extends Component {
    state = {
        showAddQualificationDrawer: false,
        record:{}
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }
    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getAllQualifcationScores(params)
            resolve(response)
        })
    }

    deleteScore = async(recordId) =>{
        let response = await Request.deleteQualificationScore({recordId})
        if(response.success) {
            notification.success({
                message:response.message
            })
        }else {
            response.error({
                message:response.message
            })
        }
        this.table.current.reload()
    }

    editScore = (record) =>{
        this.setState({showAddQualificationDrawer:true, record:record})
    }

    showAddDrawer = () => {
        this.setState({ showAddQualificationDrawer: true })
    }

    closeQualificationDrawer = () => {
        this.setState({ showAddQualificationDrawer: false, record:{} }, () => {
            this.table.current.reload()
        })
    }
    render() {
        const columns = [
            {
                title: 'Percentange',
                key: 'percentage'
            },
            {
                title: 'CGPA 10.0',
                key: 'cgpa10'
            },
            {
                title: 'Letter Grade',
                key: 'letterGrade'
            },
            {
                title: 'CGPA 5.0',
                key: 'gpa5'
            },
            {
                title: 'CGPA 4.0',
                key: 'gpa4'
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => <>
                    <Tooltip title="Edit Score">
                        <Button
                            size="small"
                            shape="circle"
                            onClick={() => {
                                this.editScore(record)
                            }}
                            icon="edit"
                        />
                    </Tooltip>
                    <Tooltip title="Delete Score">
                        <Button
                            size="small"
                            shape="circle"
                            onClick={() => {
                                this.deleteScore(record._id)
                            }}
                            icon="delete"
                        />
                    </Tooltip>
                </>
            }
        ]
        return (
            <PageHeaderWrapper title={`Qualification Scores`}>
                {
                    this.state.showAddQualificationDrawer ?
                        <AddQualificationScore record={this.state.record} onClose={this.closeQualificationDrawer} />
                        : null
                }
                <Card style={{ marginBottom: 10 }}>
                    <Row gutter={16}>
                        <Col span={12}></Col>
                        <Col span={10}></Col>
                        <Col span={2}>
                            <Button type="primary" onClick={() => this.showAddDrawer()}>Add</Button>
                        </Col>
                    </Row>
                </Card>

                <Card bordered={true}>
                    <TableComp columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1200 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ["10", "20", "50", "100", "1000"],
                        }} />
                </Card>

            </PageHeaderWrapper>
        )
    }
}





const mapStateToProps = ({ global }) => ({
    categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllQualificationScores);